export default "__VITE_ASSET__DmQ3g63N__"